import React, { useState } from "react";
import { CloudArrowDownIcon } from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import { editAccountInitialValues, getUser } from "../../../data/account/selectors/user";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import cx from 'classnames';
import Tooltip from "../../../ui/shared/components/Tooltip";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useDispatch } from "react-redux";
import { removeImage } from "../../../data/account/actions/account";


const ImageUploadWithPreview = ({ input, id = "dropzone-file" }) => {
  const { t } = useTranslation();
  const initialValues = useSelector((state) =>
  editAccountInitialValues(getUser(state))
  );
  const [file, setFile] = useState(initialValues.agencyImage);
  const dispatch = useDispatch();

  const handleFileChange = (e) => {
    input.onChange(e.target.files[0])
    setFile(URL.createObjectURL(e.target.files[0]));
  }

  const handleFileDelete = () => {
    dispatch(removeImage());
    setFile(null);
  }

  return (
    <div className={cx("", {
      "relative bg-white border p-2 shadow-lg": !isEmpty(file)
  })}>
      <div className="h-fit w-64 flex justify-center">
          {!isEmpty(file)? 
            <div className="w-fit h-fit">
              <img name="agencyImage" src={file} className="max-h-64 max-w-64 bg-white object-contain border-none group-hover:rounded-full" />
              <span onClick={() => {setFile(null)}} className="absolute top-[-10px] right-[-10px] bg-gray-200 rounded-full border border-gray-500 text-gray-500 cursor-pointer hover:scale-110 hover:bg-gray-600 hover:text-gray-200">
                <Tooltip Icon={() => <XMarkIcon className="h-5 w-5" />} content={t('account_button.remove_logo')} />
              </span>
            </div>
          : <>
              <label htmlFor={id} className="flex flex-col items-center justify-center w-full h-64 cursor-pointer rounded-full bg-gray-700">
                <div className="flex flex-col items-center justify-center p-5 text-center">
                  <CloudArrowDownIcon className="h-12 w-12 text-gray-400" />
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">Cliquez pour téléverser</span> ou faites un glisser et déposez</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">SVG, PNG, JPG ou GIF (MAX. 800x400px)</p>
                </div>
              </label>
              <input id={id} type="file" className="hidden" onChange={handleFileChange} />
            </>
          }
      </div>
      {!isEmpty(file) && <span onClick={handleFileDelete} className="absolute top-[-10px] right-[-10px] bg-gray-200 rounded-full border border-gray-500 text-gray-500 cursor-pointer hover:scale-110 hover:bg-gray-600 hover:text-gray-200">
        <Tooltip Icon={() => <XMarkIcon className="h-5 w-5" />} content={t('account_button.remove_logo')} />
      </span>}
    </div>
  )
}

export default ImageUploadWithPreview;